const patchNotificationRequest = (notification) => {
  return { ids: [notification.id] };
};

export default patchNotificationRequest;
